import React, { useState } from 'react';
import styles from './Status.module.css';
import { useAppSelector } from 'src/hooks/hooks';
import { DesignStatus } from 'src/enums/design-status';
import { Message } from 'src/components/message/Message';
import { useTranslation } from 'react-i18next';
import { selectDesignStatus } from 'src/store/design/designSelects';
import { shallowEqual } from 'react-redux';
import biLoggingService, { ActionType, ObjectType, UserActionData } from 'src/services/bi-logging/bi-logging.service';

import { SendForm } from '../send-form/SendForm';
import { Button } from '../button/Button';

interface StatusState {
    show: boolean;
    status: DesignStatus;
}

export function Status() {
    const designStatus = useAppSelector(selectDesignStatus, shallowEqual);

    const [statusState, setStatusState] = useState<StatusState>({
        show: false,
        status: DesignStatus.None,
    });
    const { t } = useTranslation();
    const objectNameApprove = 'approve_button';
    const objectNameReject = 'reject_button';
    const locationName = 'exocad-3d-viewer page';

    const buttons = () => {
        return (
            <div className={`${styles.buttons} ${styles.container}`}>
                <Button
                    id="e3dv_return"
                    className={`${styles.btn} ${styles.red}`}
                    name={t('SharedDesignAction.Button.Return')}
                    onClick={() => {
                        setStatusState({
                            show: true,
                            status: DesignStatus.Rejected,
                        });
                        sendEvent(objectNameReject);
                    }}
                />

                <Button
                    id="e3dv_approve"
                    className={`${styles.approve} ${styles.btn} ${styles.blue}`}
                    name={t('SharedDesignAction.Button.Approve')}
                    onClick={() => {
                        setStatusState({
                            show: true,
                            status: DesignStatus.Approved,
                        });
                        sendEvent(objectNameApprove);
                    }}
                />
            </div>
        );
    };

    const sendEvent = (objectName: string,
                       action: ActionType = ActionType.Click,
                       objectType: ObjectType = ObjectType.Button,
                       locationParentObject: string = locationName,
                       selectedValue: string = '',
                       automationId: string = '') => {
        const userActionData: UserActionData = {
            objectName,
            action,
            objectType,
            locationParentObject,
            selectedValue,
            automationId
        };
        biLoggingService.sendUserAction(userActionData);
    }

    const sendForm = () => (
        <div className={`${styles.container}`}>
            <SendForm
                status={statusState.status}
                onBack={() => {
                    setStatusState({
                        show: false,
                        status: DesignStatus.None,
                    });
                }}
            />
        </div>
    );

    const controls = () => {
        if (designStatus !== DesignStatus.None) {
            return <Message id="e3dv_design_status_text" designStatus={designStatus} />;
        }

        return statusState.show ? sendForm() : buttons();
    };

    return controls();
}
